import FDictionary from '../__select';

export default class FDictionaryDepartment extends FDictionary {
  dictionary = 'department';
}
